export default __webpack_public_path__ + "74866d995c68581de12ad30682749a5c.svg";